module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page404"
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('h3', {}, [_vm._v("QLINK酷联客官网")]), _vm._v(" "), _c('small', [_vm._v("全新改版升级中···")]), _vm._v(" "), _c('p', [_vm._v("敬请期待！")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.fnToRouter('/')
      }
    }
  }, [_vm._v("返回主页")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回上一页")]), _vm._v(" "), _c('div', [_vm._v("资讯热线0592-8222272 / 5638000")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-ff4eeae4"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = 791
// module chunks = 1